import React from 'react';
export function Header() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const navItems = [{
    label: 'How it works',
    id: 'how-it-works'
  }, {
    label: 'About',
    id: 'about'
  }, {
    label: 'Engagements',
    id: 'engagements'
  }, {
    label: 'Scope',
    id: 'scope'
  }, {
    label: 'Fit',
    id: 'fit'
  }, {
    label: 'Contact',
    id: 'contact'
  }];
  return <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50" data-id="element-110">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-111">
        <button onClick={() => scrollToSection('hero')} className="text-sm font-bold tracking-widest uppercase text-black hover:text-gray-600 transition-colors" data-id="element-112">
          Brittney Gwynn
        </button>

        <nav className="hidden md:flex space-x-8" data-id="element-113">
          {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-xs font-medium uppercase tracking-widest text-gray-500 hover:text-black transition-colors" data-id="element-114">
              {item.label}
            </button>)}
        </nav>

        <button onClick={() => scrollToSection('contact')} className="md:hidden text-xs font-medium uppercase tracking-widest text-black" data-id="element-115">
          Menu
        </button>
      </div>
    </header>;
}